import classes from './Splash.module.scss'
import React, {MutableRefObject, useRef} from "react";
import {animated, useChain, useSpring, useTransition} from "react-spring";
import {springConfig} from "../../const";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-light-svg-icons";
import {useViewportSize} from "../../hooks/useViewportSize";

interface Props {
	containerRef: MutableRefObject<HTMLDivElement | null>
}

const Splash = (props: Props) => {
	const {height} = useViewportSize()

	const [, setY] = useSpring(() => ({
		y: 0,
	}))

	const onArrowClick = () => {
		// @ts-ignore
		setY(() => ({
			y: height,
			from: {
				y: props.containerRef.current?.scrollTop ?? 0
			},
			onFrame: ({y}: { y: number }) => props.containerRef.current?.scrollTo(0, Math.floor(y)),
			reset: true,
			config: {
				clamp: true
			}
		}))
	}

	const nameSpringRef = useRef(null);
	const nameSpring = useSpring({
		from: {
			transform: 'translateY(10vh)',
			opacity: 0
		},
		transform: 'translateY(0)',
		opacity: 1,
		config: springConfig,
		ref: nameSpringRef
	})

	const items = ['Programování ', '|', ' Fotografování', ' | ', 'Chytrá domácnost']

	const skillsTransitionRef = useRef(null)
	const skillsTransition = useTransition(items, item => item, {
		from: {
			transform: 'translateY(10vh)',
			opacity: 0
		},
		enter: {
			transform: 'translateY(0)',
			opacity: 1,
		},
		config: springConfig,
		trail: 200,
		ref: skillsTransitionRef
	})

	const arrowTransitionRef = useRef(null)
	const arrowTransition = useTransition([0, 1, 2], item => item, {
		from: {
			opacity: 0,
		},
		enter: {
			opacity: 1,
		},
		leave: {
			opacity: 0
		},
		config: springConfig,
		trail: 200,
		ref: arrowTransitionRef
	})

	useChain([nameSpringRef, skillsTransitionRef, arrowTransitionRef], [0, 0.6, 1])

	return (
		<div className={classes.root}>
			<div className={classes.text}>
				<animated.h1 style={nameSpring}>Robin Ilyk</animated.h1>
				<div className={classes.skills}>
					{skillsTransition.map(value => (
						<animated.h3 style={value.props} key={value.key}>{value.item}</animated.h3>
					))}
				</div>
			</div>
			<div className={classes.arrow}>
				{arrowTransition.map((item, index) => {
					const Icon = animated(FontAwesomeIcon)
					return <Icon
						size='2x'
						key={item.key}
						onClick={onArrowClick}
						style={{
							opacity: item.props.opacity,
							transform: item.props.opacity?.interpolate(o => `translateY(calc(-${o}rem * ${index * 1.2}))`)
						}}
						icon={faChevronDown}
					/>
				})}
			</div>
		</div>
	)
}

export default Splash